<template lang="jade">
  .login-wrapper
    .logo
    .login-bg
      .form-title Referrals Query System
      form.login-form
        input.username.login-input(type="text" v-model="username" placeholder="Username", :class="{ active: usernameErrorShow }")
        input.password.login-input(type="password" v-model="password" Placeholder="Password", :class="{ active: passwordErrorShow }")
        .verification(v-show="verificationShow")
          input.verification.login-input(ref="code", type="text" v-model="imageCode" Placeholder="Verification code", :class="{ active: verificationErrorShow }" maxlength="4")
          img.verification-img(:src="verifycodeSrc", @click="getVerifyCode")
        .error-msg(v-show="signErrorShow") {{ signErrorMsg }}
        button.login-btn(@click.prevent="sign") Sign In
        .login-tip
          | If you need help, please contact us via email:&nbsp;
          a(href="mailto:affiliate@vipkid-intl.com") affiliate@vipkid-intl.com
    .expired-container(v-show="expired")
      .alert-area
        .close-btn
        img(src="./oops.png").oops
        .text Your contract has {{ status }}, so you are unable to login.
        .text-tips If you believe this is an error or if you would like to renew your contract, please contact&nbsp;
          a(href="mailto:affiliate@vipkid-intl.com") affiliate@vipkid-intl.com.
        .ok-btn(@click="closeExpiredDialog") OK
    //- .expired-container(v-show="ended")
    //-   .alert-area
    //-     .close-btn
    //-     img(src="./oops.png").oops
    //-     .text This program has ended
    //-     .text-tips If you have any questions, please contact&nbsp;
    //-       a(href="mailto:affiliate@vipkid-intl.com") affiliate@vipkid-intl.com.
    //-     .ok-btn(@click="closeEndedDialog") OK

</template>

<style lang="stylus" scoped>
  .login-wrapper
    position: fixed
    top: 0
    left: 0
    right: 0
    bottom: 0
    background-image: url('./login_bg.png')
    background-size: cover
    background-repeat: no-repeat
    .login-bg
      position: fixed
      top: 0
      left: 0
      right: 0
      bottom: 0
      width: 100%
      height: 100%
      background: rgba(0, 0, 0, .5)
    .logo
      position: absolute
      width: 94px
      height: 30px
      top: 20px
      left: 20px
      background-image: url('./logo_white.png')
      background-size: cover
      background-repeat: no-repeat
      z-index: 2
    .form-title
      font-size: 50px
      line-height: 48px
      margin-top: 200px
      color: #FFF
      text-align: center
      font-family: Roboto-regular
    .login-form
      width: 100%
      margin-top: 45px
      text-align: center
      position: relative
      .login-input
        width: 280px
        height: 42px
        display: block
        border-radius: 5px
        margin: 0 auto
        font-size: 22px
        padding-left: 20px
        margin-top: 22px
        outline: 0
        border: 1px solid transparent
      .login-btn
        width: 300px
        height: 46px
        background: transparent
        outline: 0
        border: 2px solid rgba(255, 255, 255, .75)
        border-radius: 100px
        margin-top: 44px
        font-size: 28px
        color: #FFF
        font-weight: 200
        &:hover
          background: #73BA00
          border: 2px #73BA00 solid
      .verification
        width: 300px
        margin: 0 auto
        margin-top: 22px
        .verification
          width: 180px
          display: inline-block
          margin-top: 0
        .verification-img
          width: 90px
          height: 44px
          display: inline-block
          margin-left: 8px
          vertical-align: top
          border-radius: 5px
      .active
        border: 1px #F60 solid
      .login-tip
        width: 300px
        color: #FFF
        margin: 0 auto
        margin-top: 1em
        font-size: 14px
        a
          display: inline-block
          color: #73BA00
      .error-msg
        width: 100%
        margin: 0 auto
        font-size: 14px
        margin-top: 10px
        color: #F60
        position: absolute
    .expired-container
      position: fixed
      top: 0
      left: 0
      right: 0
      bottom: 0
      background: rgba(0, 0, 0, .5)
      .alert-area
        width: 540px
        height: 274px
        margin: 0 auto
        background: #FFF
        border-radius: 10px
        margin-top: 286px
        text-align: center
        position: relative
      .close-btn
        position: absolute
        top: 20px
        right: 20px
        width: 60px
        height: 60px
      .oops
        width: 60px
        height: 60px
        margin: 0 auto
        display: block
        padding-top: 20px
      .text
        margin-top: 10px
        font-size: 20px
        line-height: 2
      .text-tips
        padding: 0 80px
        a
          color: #73BA00
      .ok-btn
        width: 150px
        height: 38px
        margin: 0 auto
        margin-top: 30px
        border: 1px solid #F60
        border-radius: 100px
        font-size: 20px
        line-height: 38px
        color: #F60
        &:hover
          color: #FFF
          background: #F60
</style>

<script>
import { ElementMessageMixin } from 'api/utils.js'
import Referral from 'api/referral.api.js'

const errorMsg = {
  'USERNAMENULL': 'Please input your user name.',
  'PASSWORDNULL': 'Please input your password.',
  'SIGNUPWRONG': 'Password or user name is incorrect!',
  'VERIFICATIONEMPTY': 'Please enter the verification code.',
  'VERIFICATIONWRONG': 'Your verification code is incorrect.',
  'NOTLOGIN': 'Please sign in'
}

export default {
  mixins: [ ElementMessageMixin ],
  data () {
    return {
      username: '',
      password: '',
      imageCode: '',
      imageKey: '',
      signErrorShow: false,
      signErrorMsg: '',
      usernameErrorShow: false,
      passwordErrorShow: false,
      verificationShow: false,
      verificationErrorShow: false,
      expired: false,
      // ended: false,
      verifycodeSrc: '',
      status: 'expired'
    }
  },
  mounted () {
    // debug purpose only, DO NOT USE
    window.$loginpage = this
  },
  methods: {
    /**
     * login
     */
    sign () {
      // this.ended = true

      this.verificationErrorShow = false
      if (!this.validate()) {
        this.signErrorShow = true
        return
      } else {
        this.signErrorShow = false
        this.usernameErrorShow = false
        this.passwordErrorShow = false
      }
      let param = {
        username: this.username,
        password: this.password,
        imageCode: this.imageCode,
        key: this.imageKey
      }
      Referral.login(param)
        .then(response => {
          if (response.data.success) {
            Referral.getUserInfo().then(e => {
              if (e.data.success) {
                this.$parent.setUserInfo(e.data.data)
                this.$router.push({ path: 'referral' })
              } else {
                this.$error('Get user info failed, please try later.')
              }
            }).catch(e => {
              this.fail(e.response)
            })
          } else {
            this.fail(response)
          }
        })
        .catch(e => {
          this.fail(e.response)
        })
    },
    /**
     * show login failed messages
     * @param  {Object} error
     */
    fail (error) {
      // this.getVerifyCode()
      const code = error.data.code
      if (code === '-2' || code === '-3') {
        this.getVerifyCode()
        this.signErrorShow = true
        if (code === '-2') {
          this.signErrorMsg = errorMsg.VERIFICATIONEMPTY
        } else {
          this.signErrorMsg = errorMsg.VERIFICATIONWRONG
        }
        return
      } else if (code === '-7' || code === '-6') {
        if (code === '-6') this.status = 'locked'
        this.showExpiredDialog()
        return
      } else if (code === '-12') {
        this.signErrorMsg = errorMsg.NOTLOGIN
      }
      this.signErrorShow = true
      this.signErrorMsg = errorMsg.SIGNUPWRONG
    },
    /**
     * login form validation
     */
    validate () {
      if (this.username === '') {
        this.signErrorMsg = errorMsg.USERNAMENULL
        this.usernameErrorShow = true
        return false
      }
      if (this.password === '') {
        this.signErrorMsg = errorMsg.PASSWORDNULL
        this.usernameErrorShow = false
        this.passwordErrorShow = true
        return false
      }
      return true
    },
    /**
     * get captcha image
     */
    getVerifyCode () {
      Referral.verifycode()
        .then(respones => {
          this.imageCode = ''
          this.verifycodeSrc = respones.data.data.value
          this.imageKey = respones.data.data.key
          if (!this.verificationShow) this.verificationShow = true
          this.verificationErrorShow = true
        })
    },
    showExpiredDialog () {
      this.expired = true
    },
    closeExpiredDialog () {
      this.expired = false
    }
    // closeEndedDialog () {
    //   this.ended = false
    // }
  },
  watch: {
    verificationShow () {
      if (this.verificationShow) {
        setTimeout(() => {
          this.$refs.code.focus()
        }, 200)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// login.vue?3878726c